import gql from 'graphql-tag';

export const VODSET_DELETE = gql`
  mutation ($id: ID!){
    vodsetDelete(id: $id) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/vodsets/delete.js